export default /* GraphQL */ `
    query GetMinimalLists {
        lists: minimalLists {
            isSelected
            listId
            name
            updated
            items {
                itemNo
                quantity
            }
            designs {
                configurationId
            }
        }
    }
`;
